import { Injectable } from '@angular/core';
import { LocaleLanguage } from '@app/+authenticated/shared/locale/locale.helper';
import {
  NavatticDemoDialogComponent,
  NavatticDemoDialogData,
} from '@app/+onboarding/components/demo-dialog/navattic-demo-dialog.component';
import { UserGuideType } from '@app/reducers/orm/user-guide';
import { SmbHospitalityOnboardingChecklistStep } from '@app/shared/onboarding/onboarding-checklist.model';
import { TranslateService } from '@ngx-translate/core';
import { SbDialogService } from '@sb/ui';
import { of, switchMap, take, tap } from 'rxjs';

import { OnboardingDialogResult } from '../../../+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { OnboardingChecklistService } from '../../../shared/onboarding/onboarding-checklist.service';
import { OnboardingUtils } from '../../onboarding.utils';
import { OptimizedScheduleDialogComponent } from '../optimized-schedule/optimized-schedule-dialog.component';
import { OptimizedScheduleSummaryDialogComponent } from '../optimized-schedule/optimized-schedule-summary-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class OptimizedScheduleOnboardingService {
  public constructor(
    private readonly onboardingChecklist: OnboardingChecklistService,
    private readonly dialogService: SbDialogService,
    private readonly onboardingUtils: OnboardingUtils,
    private readonly translate: TranslateService,
  ) {}

  public openDialog(originator = 'onboarding') {
    return this.dialogService
      .setSize('xxl')
      .open(OptimizedScheduleDialogComponent, { data: { originator } })
      .closed.pipe(
        take(1),
        tap((result: OnboardingDialogResult) => {
          if (!result) {
            this.onboardingUtils.stripOnboardingParamsFromRoute();
          }
        }),
      );
  }

  public openDemo(skipFlow: boolean) {
    const langDemoMap = {
      [LocaleLanguage.ENGLISH]: 'cm4r4u3vu000403jy3irz28x3',
      [LocaleLanguage.DUTCH]: 'cm5mkiezn002s03mjewg5f5er',
      [LocaleLanguage.GERMAN]: 'cm5mgjqv6000003mkbo370iym',
    };

    const demoId = langDemoMap[this.translate.currentLang] || langDemoMap[LocaleLanguage.ENGLISH];

    return this.dialogService
      .setSize('fullscreen')
      .open<NavatticDemoDialogComponent, NavatticDemoDialogData>(NavatticDemoDialogComponent, {
        data: { demoId },
      })
      .closed.pipe(
        switchMap(() => {
          if (!skipFlow) {
            return this.onboardingChecklist.completeStep(
              UserGuideType.SELF_ONBOARDING_CHECKLIST,
              SmbHospitalityOnboardingChecklistStep.OPTIMIZED_SCHEDULE,
            );
          }
          return of(false);
        }),
      );
  }

  public openSummary(originator: string) {
    return this.dialogService
      .setSize('xxl')
      .open(OptimizedScheduleSummaryDialogComponent, { data: { originator } })
      .closed.pipe(take(1));
  }
}
